// extracted by mini-css-extract-plugin
module.exports = {"baby":"BabySearch_baby_2X208"};